import { camelize } from 'humps'

export default function convertObjAttrsSnakeToCamelCase(obj) {
  if (Array.isArray(obj)) {
    return obj.map((item) => convertObjAttrsSnakeToCamelCase(item))
  } else if (typeof obj === 'object' && obj !== null) {
    const newObj = {}
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const camelKey = key !== '_id' ? camelize(key) : key
        newObj[camelKey] = convertObjAttrsSnakeToCamelCase(obj[key])
      }
    }
    return newObj
  }
  return obj
}
